import { ApolloClient, InMemoryCache, HttpLink, ApolloLink } from '@apollo/client';
import { afterwareLink, middlewareAuthLink } from '../middlewares/apollo'
// import { removeTypenameFromVariables } from '@apollo/client/link/remove-typename';

const httpLink = new HttpLink({
    uri: process.env.NODE_ENV === "production" ? process.env.REACT_APP_PROD_API_URL : process.env.REACT_APP_API_URL,
    credentials: 'same-origin',
    headers: {
        'apollo-require-preflight': 'true'
    }
})
// const removeTypenameLink = removeTypenameFromVariables();

const link = ApolloLink.from([
    middlewareAuthLink,
    afterwareLink,
    // removeTypenameLink,
    httpLink
])

export const apolloClient = new ApolloClient({
    link,
    cache: new InMemoryCache(),
});